import React, { Component } from "react";
import {
  View,
  StyleSheet,
  Image,
  Dimensions,
  ScrollView
} from "react-native";

import Color from "react-native-material-color";

import * as Styles from "../utils/Styles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";

import Header from "../components/Header";
import Text from "../components/Text";
import * as ServerOperations from "../utils/ServerOperations";

let language = "";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let styles = {};
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import { FlatList } from "react-native-web";

class FindUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  async componentDidMount() {
  }


  render() {
    Commons.resizeHandle(window, this, () => {
      width = this.width;
      height = this.height;
    });
    styles = this.styles();
    return (
      <View style={styles.container}>
        
      </View>
    );
  }

  renderFindUs = () => {
    return (
      <View style={{ flexDirection: "row", marginTop: 50 }}>
        <Image
          style={{
            width: width / 2 - 85,
            height: (width / 2 - 85) * 0.75,
          }}
          resizeMode="contain"
          source={image1}
        />
        <View style={{
          marginLeft: width > 1000 ? 80 : 40,
        }}>
          <Text
            style={{
              fontSize: 23,
              fontFamily: this.props.fontFamily,
              color: "#6b3529",
              fontWeight: "bold",
              marginLeft: 5
            }}
          >
            FIND OUR PRODUCTS IN THESE STORES:
          </Text>
          {Styles.renderVSeparator(25)}
          <View style={{ flexDirection: "row" }}>
            {/* pantry */}
            <Image
              style={{
                width: 17,
                height: 17,
                marginRight: 5,
                resizeMode: "contain",
              }}
              source={pantryIcon}
            />
            <Text style={{ fontFamily: 'zarid', fontSize: this.state.fontSize }}>Pantry</Text>
            {Styles.renderSeparator(92)}
            {/* produce */}
            <Image
              style={{
                width: 17,
                height: 17,
                marginRight: 5,
                resizeMode: "contain",
              }}
              source={produceIcon}
            />
            <Text style={{ fontFamily: 'zarid', fontSize: this.state.fontSize }}>Produce</Text>
            {Styles.renderSeparator(92)}
            {/* eggs */}
            <Image
              style={{
                width: 17,
                height: 17,
                marginRight: 5,
                resizeMode: "contain",
              }}
              source={eggsIcon}
            />
            <Text style={{ fontFamily: 'zarid', fontSize: this.state.fontSize }}>Eggs</Text>
          </View>
          {Styles.renderVSeparator(25)}
          <FlatList
            data={this.state.locations}
            renderItem={this.renderLocation}
            keyExtractor={(item) => item.ID}
            keyboardShouldPersistTaps={"always"}
            removeClippedSubviews
            numColumns={2}
            initialNumToRender={50}
          />
        </View>
      </View >
    );
  }

  renderLocation = ({ item, index }) => {
    return (<View>
      <Text style={{
        fontFamily: this.state.fontFamily,
        fontSize: this.state.fontSize - 3,
        width: 300,
        padding: 15,
        paddingLeft: 5,
        paddingBottom: 5
      }}>{item.DESC.toUpperCase()}</Text>
      {item.LOCATIONS.map((location) =>
        <View style={{ flexDirection: "row" }}>
          <Image
            style={{
              width: 13,
              height: 13,
              marginRight: 1,
              marginTop: 1,
              resizeMode: "contain",
            }}
            source={pantryIcon}
          />
          <Image
            style={{
              width: 13,
              height: 13,
              marginRight: 1,
              marginTop: 1,
              resizeMode: "contain",
            }}
            source={produceIcon}
          />
          <Image
            style={{
              width: 13,
              height: 13,
              marginRight: 2,
              marginTop: 1,
              resizeMode: "contain",
            }}
            source={eggsIcon}
          />
          <Text style={{ fontFamily: 'zarid', fontSize: this.state.fontSize }}>{location.DESC}</Text>
        </View>
      )}
    </View>)
  }

  styles = () => ({
    container: {
      flex: 1,
      backgroundColor: "white",
    },
    image: {
      width: width / 6,
      height: width / 6,
      resizeMode: "contain",
    },
    imageHovered: {
      width: width / 5.8,
      height: width / 5.8,
      resizeMode: "contain",
    },
    row: {
      padding: 12,
      backgroundColor: "white",
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderColor: Color.GREY[500],
    },
    title: {
      fontSize: 18,
      color: "#ed9c26",
    },
    descView: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    desc: {
      fontSize: 16,
      color: "#6b3529",
      flex: 0.85,
    },
    normal: {
      fontSize: 16,
      color: "#6b3529",
    },
    dayTxt: {
      fontSize: 17,
      color: Color.GREY[800],
    },
    switch: {
      flex: 0.15,
    },
    dayRow: {
      width: "100%",
      padding: 12,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "white",
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderColor: Color.GREY[300],
    },

  });
}

export default FindUs;
